import axios from 'axios';

export function unlockCampaign(campaignId) {
  return axios
    .get(`/api/?entity=campaigns&action=unlock&campaignId=${campaignId}`)
    .then(response => (response.data ? response.data : response));
}
